import React from 'react';
import { CONFIG_TABS } from './runtimeConfigUtils';

const RuntimeConfigTabs = ({
  activeTab,
  entryCounts,
  browsedTabs = {},
  loadingBrowse,
  onTabChange,
  onBrowse,
  onAddEntry = () => {},
}) => {
  const activeLabel = CONFIG_TABS.find((t) => t.id === activeTab)?.label || activeTab;
  const isProxyTab = activeTab === 'proxy';
  const showActiveCount = browsedTabs[activeTab] && entryCounts[activeTab] != null
    ? entryCounts[activeTab]
    : null;

  return (
    <div className="runtime-config-tab-row">
      <div className="runtime-config-tabs" role="tablist" aria-label="Runtime config categories">
        {CONFIG_TABS.map((tab) => {
          const count = tab.id === activeTab && browsedTabs[tab.id]
            ? entryCounts[tab.id]
            : null;
          const label = count != null ? `${tab.label} (${count})` : tab.label;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={activeTab === tab.id ? 'active' : ''}
              onClick={() => onTabChange(tab.id)}
              data-testid={`runtime-config-tab-${tab.id}`}
            >
              {label}
            </button>
          );
        })}
      </div>
      {isProxyTab ? (
        <button
          type="button"
          className="runtime-config-browse-btn runtime-config-add-entry-btn"
          onClick={onAddEntry}
          disabled={loadingBrowse}
          data-testid="runtime-config-add-entry-btn"
        >
          Add entry
        </button>
      ) : (
        <button
          type="button"
          className="runtime-config-browse-btn"
          onClick={onBrowse}
          disabled={loadingBrowse}
          data-testid="runtime-config-browse-btn"
        >
          {loadingBrowse
            ? 'Loading…'
            : `Browse ${activeLabel}${showActiveCount != null ? ` (${showActiveCount})` : ''}`}
        </button>
      )}
    </div>
  );
};

export default RuntimeConfigTabs;
